
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quotes",
      function () {
        return require("private-next-pages/quotes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quotes"])
      });
    }
  